// 按需全局引入 vant组件
import Vue from 'vue'
import { Button, List, Cell, Tabbar, TabbarItem, Uploader, Swipe, SwipeItem, Field, NavBar, Dialog, Toast, Image, Rate, DatetimePicker, Popup, Loading, PullRefresh, ImagePreview, Overlay, CountDown,ActionSheet,Icon,Form } from 'vant'
Vue.use(Button)
Vue.use(Cell)
Vue.use(List)
Vue.use(Tabbar).use(TabbarItem)
Vue.use(Uploader)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Field)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(NavBar)
Vue.use(Image)
Vue.use(Rate)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Loading)
Vue.use(PullRefresh)
Vue.use(ImagePreview)
Vue.use(Overlay)
Vue.use(CountDown).use(ActionSheet).use(Icon).use(Form)



// WEBPACK FOOTER //
// ./src/plugins/vant.js